export const HERO_CONSTANTS = {
  TAG: "AI Technology",
  DATE: "October 23, 2023",
  TITLE: "Revolutionizing AI with Claude AI",
  DESCRIPTION:
    "Discover how Claude AI is transforming the landscape of artificial intelligence with its advanced capabilities and innovative applications.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/3184460/pexels-photo-3184460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Claude AI is at the forefront of artificial intelligence innovation, offering cutting-edge solutions that enhance various industries. This guide explores the key features and benefits of Claude AI, and how it is shaping the future of technology.",
  "From natural language processing to predictive analytics, Claude AI provides a wide range of applications that improve efficiency and decision-making. We'll delve into the technology behind Claude AI and its impact on different sectors.",
  "Whether you're a tech enthusiast or a business leader, understanding Claude AI's capabilities can help you leverage its potential to drive growth and innovation. Let's explore the transformative power of Claude AI.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Claude AI",
    content:
      "Claude AI is an advanced artificial intelligence platform that leverages machine learning and deep learning algorithms to provide intelligent solutions. Its capabilities include natural language processing, image recognition, and predictive analytics, making it a versatile tool for various applications.",
  },
  {
    title: "2. Key Features and Benefits",
    content:
      "Claude AI offers a range of features, including real-time data analysis, automated decision-making, and personalized recommendations. These capabilities help businesses improve efficiency, enhance customer experiences, and drive innovation.",
  },
  {
    title: "3. Applications in Different Industries",
    content:
      "Claude AI is used across various industries, including healthcare, finance, retail, and manufacturing. In healthcare, it aids in diagnostics and patient care. In finance, it enhances fraud detection and risk management. Retailers use Claude AI for personalized marketing, while manufacturers benefit from predictive maintenance and quality control.",
  },
  {
    title: "4. Enhancing Business Operations",
    content:
      "By integrating Claude AI into business operations, companies can streamline processes, reduce costs, and improve decision-making. The platform's ability to analyze large datasets and provide actionable insights helps businesses stay competitive in a rapidly evolving market.",
  },
  {
    title: "5. Future Trends and Developments",
    content:
      "The field of artificial intelligence is constantly evolving, with new advancements and features being introduced regularly. Staying informed about the latest trends and developments in Claude AI helps businesses leverage its full potential and stay ahead of the competition.",
  },
  {
    title: "6. Choosing the Right AI Solution",
    content:
      "When selecting an AI solution, consider factors such as compatibility, scalability, and support. Claude AI offers robust support and integration options, making it a reliable choice for businesses of all sizes.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/3184461/pexels-photo-3184461.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top AI Innovations Transforming Industries",
    description:
      "Explore the latest AI innovations that are revolutionizing various industries. Learn how these technologies are driving growth and efficiency.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184462/pexels-photo-3184462.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How AI is Shaping the Future of Technology",
    description:
      "Discover the impact of AI on the future of technology. Understand the key trends and developments that are driving AI innovation.",
  },
  {
    image:
      "https://images.pexels.com/photos/3184463/pexels-photo-3184463.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Leveraging AI for Business Growth",
    description:
      "Learn how businesses can leverage AI to drive growth and innovation. Follow our guide to understand the benefits and applications of AI in business.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Join the AI Revolution with Claude AI",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/3184464/pexels-photo-3184464.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Subscribe Now",
  COPYRIGHT: " 2024 AI Innovations. All rights reserved",
};

export const DESCRIPTIONS = [
  "Discover how AI transforms business with smart analytics and innovative solutions for growth.",
  "Advanced AI technology that helps your business make better decisions and improve efficiency.",
  "Experience the power of AI with Claude's intelligent tools for modern business challenges.",
  "Transform your operations with AI solutions that deliver real results and drive innovation.",
];
